<template>
  <div class="rmzxbomlll between">
    <div class="zxbmlf">
      <div class="list">
        <div class="item flex_start" v-for="item in 7" :key="item">
          <div class="zxitemcov">
            <img src="../../../assets/hotconsult/wzarticcove_sample.png" />
          </div>
          <div class="zxitrgtxt">
            <div class="zxwzname ellipsis">
              诚信守法经营，打击假冒伪劣，维护生活正常秩序！
            </div>
            <div class="zxwzdes">
              {{
                `“国际消费者权益日” (World Consumer Rights Day)
              是每年的3月15日，由国际消费者联 
              盟组织于1983年确定，目的在于扩大消费者权益保护的宣传，
              使之在世界范围内得到` | toEllipsisFilter(100)
              }}
            </div>
            <div class="zxwzdbqq flex_start">
              <div>2021.4.23 14:14:14</div>
              <div>
                <img src="../../../assets/hotconsult/aixinicon.png" />
                收藏
              </div>
            </div>
          </div>
          <div class="zxitmor">
            <img src="../../../assets/hotconsult/yjt.png" />
          </div>
        </div>
      </div>
      <div class="pagination mt50">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-count="pageCount"
          :current-page="currentPage"
          :pager-count="5"
          @current-change="turnpage"
          @prev-click="turnpage(--currentPage)"
          @next-click="turnpage(++currentPage)"
        >
        </el-pagination>
      </div>
    </div>
    <div class="zxbmrgcol">
        <hcrmhttj class="zxbrgchi" />
        <hcrmdzw class="zxbrgchi mt30" />
    </div>
  </div>
</template>

<script>
import hcrmhttj from "../components/hcrmhttj";
import hcrmdzw from "../components/hcrmdzw";
export default {
  components: {
    hcrmhttj,
    hcrmdzw,
  },
  data: () => ({
    currentPage: 1, //当前
    pageCount: 17, //总页数
    total: 17, //总条目
  }),
  methods: {
    turnpage(e) {
      console.log(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.rmzxbomlll {
  align-items: flex-start;
  width: 1200px;
  margin: 0 auto;
  padding: 30px 0 50px;
  .zxbmlf {
    width: 856px;
    .list {
      .item {
        width: 810px;
        height: 190px;
        padding: 20px;
        align-items: flex-start;
        position: relative;
        cursor: pointer;
        .zxitemcov {
          margin-right: 20px;
          img {
            width: 255px;
            height: 150px;
          }
        }
        .zxitrgtxt {
          .zxwzname {
            width: 495px;
            margin-top: 15px;
            font-size: 14px;
            color: #333333;
          }
          .zxwzdes {
            width: 495px;
            height: 40px;
            margin-top: 15px;
            font-size: 12px;
            color: #666666;
            line-height: 20px;
          }
          .zxwzdbqq {
            margin-top: 25px;
            font-size: 12px;
            color: #ccc;
            > div {
              margin-right: 30px;
            }
            img {
              width: 13px;
              height: 10px;
              margin-right: 4px;
            }
          }
        }
        .zxitmor {
          display: none;
          position: absolute;
          bottom: 35px;
          right: 25px;
          img {
            width: 24px;
            height: 24px;
          }
        }
        &:hover {
          background: #f6f6f6;
          .zxitrgtxt .zxwzname {
            color: #0465ea;
          }
          .zxitmor {
            display: block;
          }
        }
      }
    }
    .pagination {
      text-align: center;
      ::v-deep .el-pagination.is-background .btn-next,
      ::v-deep .el-pagination.is-background .btn-prev,
      ::v-deep .el-pagination button,
      ::v-deep .el-pagination span:not([class*="suffix"]),
      ::v-deep .el-pagination.is-background .el-pager li {
        min-width: 36px;
        height: 36px;
        line-height: 36px;
      }
      ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active,
      ::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #ffffff !important;
        background: #0057ff !important;
      }
      .textnum {
        color: #333;
        margin-top: 15px;
      }
    }
  }
  .zxbmrgcol {
    .zxbrgchi {
      width: 302px;
      background: #ffffff;
      box-shadow: 1px 1px 6px 0px rgba(0, 0, 0, 0.08);
    }
  }
}
</style>